// potentially overriding changes.
import { createContext } from 'react';
const OpenEndedCodingContext = createContext({
  // handlers
  filterResponses: () => {},
  setShowOecModal: () => {},
  setResponsesPage: () => {},
  deleteThemeHandler: () => {},
  updateThemeHandler: () => {},
  createThemeHandler: () => {},
  reloadResponses: () => {},
  getKeywords: () => {},
  handleTrainingFinished: () => {},
  handleRemoveThemesFromResponse: () => {},
  handleAddThemesToResponse: () => {},
  handleCreateThemeForResponse: () => {},
  setShouldRefetch: () => {}
});
OpenEndedCodingContext.displayName = 'OpenEndedCodingContext';
export default OpenEndedCodingContext;